import { render, staticRenderFns } from "./PersonnelRecordDetailsTabCertificates.vue?vue&type=template&id=0c618908"
import script from "./PersonnelRecordDetailsTabCertificates.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordDetailsTabCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports